import React from 'react';
import { Tooltip, Typography } from 'antd';
import { getCountryLabel, formatUsdFen, formatCnyFen, hasRegionPricing } from '../../../utils/regionPricing';

const { Text } = Typography;

const labelStyle = { fontSize: 12, color: '#bfbfbf' };
const lineStyle = { lineHeight: '20px' };

// ══════════════════════════════════════════════
//  套餐售价 / 底价 只读展示（商城位、推荐位共用）
//  数据来源《套餐配置》，运营位不可编辑
// ──────────────────────────────────────────────

// 国内售价（CNY，订阅 / 非订阅分别展示）
export const DomesticPrice = ({ pkg }) => {
    if (pkg.isFree === 1) return <span style={{ fontSize: 12, color: '#bfbfbf' }}>免费</span>;
    const items = [];
    if (pkg.isSubscription === 1) items.push({ key: '订阅', value: pkg.salePriceCny });
    if (pkg.isNoSubscription === 1) items.push({ key: '非订阅', value: pkg.noSubscriptionPriceCny });
    if (items.length === 0) return '-';
    return items.map(i => (
        <div key={i.key} style={lineStyle}>
            <span style={labelStyle}>{i.key} </span>
            <span style={{ color: '#ff4d4f' }}>{formatCnyFen(i.value)}</span>
        </div>
    ));
};

// 海外售价（区域定价：海外默认 USD + 国家覆盖，只读）
export const OverseasPrice = ({ pkg }) => {
    if (pkg.isFree === 1) return <span style={{ fontSize: 12, color: '#bfbfbf' }}>免费</span>;
    const items = [];
    if (pkg.isSubscription === 1) items.push({ key: '订阅', regionPricing: pkg.subscriptionRegionPricing });
    if (pkg.isNoSubscription === 1) items.push({ key: '非订阅', regionPricing: pkg.noSubscriptionRegionPricing });
    if (items.length === 0) return '-';
    return items.map(i => {
        const countries = (i.regionPricing?.countryOverrides || []).filter(c => c && c.country);
        return (
            <div key={i.key} style={lineStyle}>
                <span style={labelStyle}>{i.key} </span>
                {!hasRegionPricing(i.regionPricing)
                    ? <Text type="secondary" style={{ fontSize: 12 }}>未配置</Text>
                    : (
                        <Tooltip title={countries.length
                            ? countries.map(c => `${getCountryLabel(c.country)} ${formatUsdFen(c.usdPrice)}`).join('、')
                            : '未设置国家覆盖'}>
                            <span style={{ color: '#8c8c8c' }}>
                                {formatUsdFen(i.regionPricing.defaultUsd)}{countries.length ? ` · ${countries.length} 国覆盖` : ''}
                            </span>
                        </Tooltip>
                    )}
            </div>
        );
    });
};

// 套餐底价（平台成本，只读）；inline=true 时单行展示
export const CostPrice = ({ pkg, inline = false }) => {
    if (pkg.platformCostCny == null && pkg.platformCostUsd == null) return '-';
    if (inline) {
        const parts = [];
        if (pkg.platformCostCny != null) parts.push(formatCnyFen(pkg.platformCostCny));
        if (pkg.platformCostUsd != null) parts.push(formatUsdFen(pkg.platformCostUsd));
        return <span style={{ color: '#909399' }}>{parts.join(' / ')}</span>;
    }
    return (
        <div>
            {pkg.platformCostCny != null && <div>{formatCnyFen(pkg.platformCostCny)}</div>}
            {pkg.platformCostUsd != null && <div style={{ color: '#8c8c8c' }}>{formatUsdFen(pkg.platformCostUsd)}</div>}
        </div>
    );
};
